<template>
  <div class="ui-picker-item-wrapper" :style="{ height: `${cellCount * cellH}px` }">
    <ul
      class="picker-list"
      :style="{ transform: 'translate3d(0, ' + translateY + 'px' + ', 0)', transition: 'all ' + transitionTime + 's' }"
      ref="pickerItem"
    >
      <li
        class="item"
        v-for="(item, index) in dataList"
        :key="index"
        :style="{ height: `${cellH}px`, lineHeight: `${cellH}px` }"
        :class="activeIndex === index ? 'active' : ''"
      >
        {{ item[labelKey] }}
      </li>
    </ul>
    <div class="mask" @touchstart.stop.prevent="touchStart" @touchmove.stop.prevent="touchMove" @touchend.stop.prevent="touchEnd"></div>
    <!-- <div class="picker-mask"></div> -->
    <!-- <div class="picker-indicator"></div> -->
    <div class="line" :style="{ top: `${cellH}px` }"></div>
  </div>
</template>

<script>
import remToPx from "@/utils/remToPx"

export default {
  name: "nfPickerItem",
  props: {
    // 数据列表
    dataList: {
      type: Array,
      default() {
        return []
      }
    },
    // 当前数据index，用于传递当前选择的数据的index
    dataIndex: {
      type: [Number, String],
      default: 0
    },
    beginCount: {
      type: Number,
      default: 0
    },
    cellH: {
      type: Number,
      default: remToPx(0.8)
    },
    cellCount: {
      type: Number,
      default: 5
    },
    labelKey: {
      type: String,
      default: "name"
    }
  },
  data() {
    return {
      translateY: 0,
      translateY0: 0, // 记录touchsatrt时的translate，用于touchmove叠加
      transitionTime: 0.3,
      startPageY: 0, // 记录点击开始的PageY
      endPageY: 0, // 记录点击结束后的PageY
      disPageY: 0, // 记录点击开始到结束PageY偏移量
      deceleration: -3000, // 当touchend时做匀减速运动的减速度
      speed0: 0, // touchend时的初速度
      touchTime: 0, // touchstart到touchend时间,用于计算初速度
      touchTimer: null // 定时器对象
    }
  },
  methods: {
    touchStart(e) {
      this.transitionTime = 0
      let style = window.getComputedStyle(this.$refs.pickerItem, null)
      let tran = style.transform
        .toString()
        .split(",")
        .slice(-1)[0]
        .replace(")", "")
      this.translateY = parseFloat(tran)
      this.startPageY = e.changedTouches[0].pageY
      this.translateY0 = this.translateY
      this.initTimer()
    },
    touchMove(e) {
      let movePageY = e.changedTouches[0].pageY
      let disPageY = movePageY - this.startPageY
      this.translateY = this.translateY0 + parseInt(disPageY)
    },
    touchEnd(e) {
      if (this.touchTimer) {
        clearInterval(this.touchTimer)
      }
      this.endPageY = e.changedTouches[0].pageY
      this.disPageY = this.endPageY - this.startPageY
      this.translateY = this.translateY0 + this.disPageY
      this.getDistance()
    },
    // 计时器
    initTimer() {
      if (this.touchTimer) {
        clearInterval(this.touchTimer)
      }
      this.touchTime = 0
      this.touchTimer = setInterval(() => {
        this.touchTime += 16.7
      }, 16.7)
    },
    // 获取匀减速后停止的位移
    getDistance() {
      this.transitionTime = 0.5
      this.speed0 = (1000 * this.disPageY) / this.touchTime
      let t = Math.abs((0 - this.speed0) / this.deceleration)
      let s = parseFloat(((this.speed0 * t) / 2).toFixed(2))
      let dis = this.translateY + s - this.beginCount * this.cellH
      // 传递index出去
      this.getCurrentIndex()
      // 上边界
      if (dis > 0) {
        this.translateY = parseInt(this.beginCount * this.cellH)
        return
      }
      // 下边界
      let bottomMax = -1 * this.dataList.length * this.cellH + this.cellH
      if (dis < bottomMax) {
        this.translateY = bottomMax + this.beginCount * this.cellH
        return
      }
      let intDis = parseInt(Math.abs(dis) / this.cellH)
      let remainder = dis % this.cellH
      // 方向
      let dir = dis < 0 ? -1 : 1
      Math.abs(remainder) > this.cellH / 2 && intDis++
      s = this.cellH * intDis * dir
      this.translateY = parseFloat(s + this.beginCount * this.cellH)
    },
    // 获取当前数组下标
    getCurrentIndex() {
      let timer = setTimeout(() => {
        let tran = this.translateY - this.beginCount * this.cellH
        let index = Math.abs(Math.round(tran / this.cellH))
        let obj = {
          key: this.dataIndex,
          index: index
        }
        this.$emit("getSelIndex", obj)
        clearTimeout(timer)
      }, 0)
    },
    // 刷新
    refresh() {
      this.transitionTime = 0.05
      this.translateY = this.beginCount * this.cellH
      this.getCurrentIndex()
      let timer = setTimeout(() => {
        if (this.transitionTime) {
          this.transitionTime = 0.5
        }
        clearTimeout(timer)
      }, 50)
    }
  },
  computed: {
    activeIndex() {
      const tran = this.translateY - this.beginCount * this.cellH
      const index = Math.abs(Math.round(tran / this.cellH))
      return this.translateY > 0 ? "" : index
    }
  },
  mounted() {
    this.getCurrentIndex()
  }
}
</script>

<style lang="scss" scoped>
.ui-picker-item-wrapper {
  position: relative;
  height: 238px;
  flex: 1 0;
  overflow: hidden;
  .mask {
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    z-index: 10;
    background: transparent;
  }
  .line {
    position: absolute;
    left: 0;
    right: 0;
    z-index: 1;
    border-bottom: 1px solid #dddddd;
  }
  .picker-list {
    min-height: 100%;
    position: relative;
    overflow: hidden;
  }
  .item {
    padding: 0;
    font-family: PingFangSC-Regular;
    font-size: 0.32rem;
    color: #999999;
    letter-spacing: 0;
    text-align: center;
    text-align: center;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    &.active {
      font-size: 0.32rem;
      color: #303233;
      font-weight: bold;
    }
  }
  .picker-mask {
    position: absolute;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    height: 100%;
    width: 100%;
    z-index: 10;
    background: linear-gradient(180deg, rgba(255, 255, 255, 0.95), rgba(255, 255, 255, 0.6)),
      linear-gradient(0deg, rgba(255, 255, 255, 0.95), rgba(255, 255, 255, 0.6));
    background-position: top, bottom;
    background-size: 100% 102px;
    background-repeat: no-repeat;
  }
  .picker-indicator {
    border-top: 1px solid #e5e5e5;
    border-bottom: 1px solid #e5e5e5;
    position: absolute;
    top: 102px;
    left: 0;
    right: 0;
    bottom: 0;
    height: 34px;
    width: 100%;
    z-index: 1;
    box-sizing: border-box;
  }
}
</style>
